function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import { cookActiveAccountForSelectors } from '@signal/core/auth';
import { useContextsInReduxForm } from '@signal/core/contextFetch/hooks';
import { cookUserAccountsForSelectors } from '@signal/core/user';
import { ActiveAccountContext, UserAccountsContext } from '@signal/core/user/Context';
import { Divider } from '../MainNavUserMenu/styles';
import Typography from '../Typography';
import { dealerGroupSelector } from './selectors';
import { Wrapper, Title, DealerGroupings, GroupAccount } from './styles';
var REDUX_COOKERS = [{
  context: ActiveAccountContext,
  cookers: [cookActiveAccountForSelectors]
}, {
  context: UserAccountsContext,
  cookers: [cookUserAccountsForSelectors]
}];
export function DealerGroupList(_ref) {
  var onAccountChange = _ref.onAccountChange;
  var selectorState = useContextsInReduxForm(REDUX_COOKERS);
  var dealerGroups = dealerGroupSelector(selectorState);

  if (!dealerGroups.length) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(DealerGroupings, {
    component: "nav"
  }, dealerGroups.map(function (_ref2) {
    var levelDisplay = _ref2.levelDisplay,
        account = _objectWithoutProperties(_ref2, ["levelDisplay"]);

    return /*#__PURE__*/React.createElement("div", {
      key: account.accountId
    }, /*#__PURE__*/React.createElement(Title, null, levelDisplay), /*#__PURE__*/React.createElement(GroupAccount, {
      onClick: onAccountChange(account)
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, account.name)));
  }))));
}
export default /*#__PURE__*/memo(DealerGroupList);